import {WSPIcon} from '@mintdata-wsp/resources/icons/WSPIcon';
import {WSPIcons, WSPIconSize} from '@mintdata-wsp/resources/icons/WSPIcons';
import {BaseComponentWithContext} from '@mintdata/mint-kit/api/components/BaseComponentWithContext';
import {GUID} from '@mintdata/mint-kit/api/models/GUID';
import {Popover} from '@mintdata/mint-kit/impl/components/popover/Popover';
import {IPopupProps} from '@mintdata/mint-kit/impl/components/popover/PopupTypes';
import {IdUtil} from '@mintdata/mint-kit/impl/util/IDUtil';
import bind from 'bind-decorator';
import {action, observable} from 'mobx';
import {observer} from 'mobx-react';
import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('./CustomDropdown.less');
const cx = classnames.bind(styles);

interface CustomDropdownState
{
    isOpen:boolean,
}

interface CustomDropdownProps
{
    renderListFunc:(closePopoverFunc:()=>void)=>JSX.Element,
    className?:string,
    title?:string | JSX.Element
    disabled?:boolean,
    ddIcon?:JSX.Element,
    ddIconClassName?:string,
    popoverProps?:Partial<IPopupProps>,
    onClick?:(event:React.MouseEvent<any>) => void,
    onDoubleClick?:(event:React.MouseEvent<any>) => void,
    onPopoverClose?:() => void,
}

@observer
export class CustomDropdown extends BaseComponentWithContext<CustomDropdownProps, CustomDropdownState>
{
    private readonly _popoverId:GUID = IdUtil.newGUID();

    static defaultProps:Partial<CustomDropdownProps> = {
        title: '',
        popoverProps: {},
    };

    @observable
    private _state:CustomDropdownState = {
        isOpen: false,
    };

    @action.bound
    private _openPopover():void
    {
        this._state.isOpen = true;
    }

    @action.bound
    private _closePopover():void
    {
        this.props.onPopoverClose && this.props.onPopoverClose();

        this._state.isOpen = false;
    }

    @bind
    private _handleClick(event:React.MouseEvent<HTMLDivElement>):void
    {
        if (this._state.isOpen)
            this._closePopover();
        else
            this._openPopover();

        this.props.onClick && this.props.onClick(event);
    }

    private _renderPopover():JSX.Element
    {
        const {renderListFunc} = this.props;

        return (
            <Popover
                id={this._popoverId}
                isModal={false}
                stickToSource={true}
                onDismissed={this._closePopover}
                style={{
                    overflowY: 'initial',
                    paddingBottom: '10px'
                }}
            >
                {renderListFunc(this._closePopover)}
            </Popover>
        );
    }


    render():JSX.Element | false | null
    {
        const {isOpen} = this._state;
        const {title, onDoubleClick, className, ddIcon, ddIconClassName, disabled,
            popoverProps: {sourceAnchor, popupAnchor}} = this.props;

        return (
            <div
                ref={this.context.popupManager.position(
                    this._popoverId,
                    sourceAnchor,
                    popupAnchor
                )}
                className={cx('base', {
                    isOpen,
                    disabled,
                    [className]: !!className
                })}
                onDoubleClick={!disabled && onDoubleClick}
                onClick={!disabled && this._handleClick}
            >
                <div className={cx('value')}>{title}</div>
                <div className={cx('collapseIcon', {[ddIconClassName]: !!ddIconClassName})}>
                    {ddIcon
                        ? ddIcon
                        : <WSPIcon
                            name={isOpen ? WSPIcons.common.ArrowUp : WSPIcons.common.ArrowDown}
                            size={WSPIconSize.medium16}
                        />
                    }
                </div>
                {isOpen && this._renderPopover()}
            </div>
        );
    }
}
